"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePostDetailTypeEnum = void 0;
var InvoicePostDetailTypeEnum;
(function (InvoicePostDetailTypeEnum) {
    InvoicePostDetailTypeEnum["License"] = "License";
    InvoicePostDetailTypeEnum["VoiceTariff"] = "VoiceTariff";
    InvoicePostDetailTypeEnum["PhonenumberMonthlyCost"] = "PhonenumberMonthlyCost";
    InvoicePostDetailTypeEnum["PhonenumberSetupCost"] = "PhonenumberSetupCost";
    InvoicePostDetailTypeEnum["VoiceUsage"] = "VoiceUsage";
    InvoicePostDetailTypeEnum["FormUsage"] = "FormUsage";
    InvoicePostDetailTypeEnum["EmailUsage"] = "EmailUsage";
    InvoicePostDetailTypeEnum["EmailAttachmentsStorage"] = "EmailAttachmentsStorage";
    InvoicePostDetailTypeEnum["FormAttachmentsStorage"] = "FormAttachmentsStorage";
    InvoicePostDetailTypeEnum["VoiceRecording"] = "VoiceRecording";
    InvoicePostDetailTypeEnum["VoiceRecordingStorage"] = "VoiceRecordingStorage";
    InvoicePostDetailTypeEnum["VoiceRecordingTranscript"] = "VoiceRecordingTranscript";
    InvoicePostDetailTypeEnum["AiRequestKbAssistant"] = "AiRequestKbAssistant";
    InvoicePostDetailTypeEnum["TextToVoiceUsage"] = "TextToVoiceUsage";
})(InvoicePostDetailTypeEnum = exports.InvoicePostDetailTypeEnum || (exports.InvoicePostDetailTypeEnum = {}));
